import { render, staticRenderFns } from "./listdetailed.vue?vue&type=template&id=1600e8d8&scoped=true"
import script from "./listdetailed.vue?vue&type=script&lang=js"
export * from "./listdetailed.vue?vue&type=script&lang=js"
import style0 from "./listdetailed.vue?vue&type=style&index=0&id=1600e8d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600e8d8",
  null
  
)

export default component.exports